import { connect } from 'react-redux';

import { IState } from '../../../store';
import { ISimilarOffersGroupsProps, SimilarOffersGroups } from './SimilarOffersGroups';
import { hasWithoutCompetitors } from '../utils/hasWithoutCompetitors';
import { isOffersFromHistoryExperiment } from '../../../utils/offersFromHistoryExperiment';

export function mapStateToProps(state: IState): ISimilarOffersGroupsProps {
  const { similarOffers, abUseExperiments } = state;
  const shouldRenderCompetitorsOffers = !hasWithoutCompetitors(similarOffers);
  const historyBasedVisible = isOffersFromHistoryExperiment(abUseExperiments) && shouldRenderCompetitorsOffers;

  return { itemBasedVisible: shouldRenderCompetitorsOffers, historyBasedVisible };
}

export const SimilarOffersGroupsContainer = connect<ISimilarOffersGroupsProps>(mapStateToProps)(SimilarOffersGroups);
